const middleware = {}

middleware['lang'] = require('../middleware/lang.js')
middleware['lang'] = middleware['lang'].default || middleware['lang']

export default middleware
